import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { RootState } from '@/store/index';
import { updateUserProfileApiCall, sendEmailOtpApiCall } from '@/services/api'
import { setProfileStepNo } from "@/store/slices/profile/profileStepNo"
import { updateProfileFields } from "@/store/slices/profile/profileSlice"
import { listOfSections } from "@/pages/profile/sections/basicDetails/constants"
import { capitalizeFirstLetter, getCountryByValue, formatNumberInputWithSpaceAfter5Numbers, undo_formatNumberInputWithSpaceAfter5Numbers, removeLeadingPlus } from "@/utils"
import moment from "moment";

import BasicDetailsView from './view'

export default function BasicDetails() {
    const { common } = useLocalTranslation();
    const dispatch = useDispatch()
    const profileDetails = useSelector((state: RootState) => state.profileReducer.profile);
    const profileStepNo = useSelector((state: RootState) => state.profileStepNoReducer.profileStepNo);

    const [errMsg, setErrMsg] = useState("")
    const [isSubmitBtnLoading, setIsSubmitBtnLoading] = useState(false)
    const [displayName, setDisplayName] = useState("")
    const [username, setUsername] = useState("")
    const [email, setEmail] = useState("")
    const [dob, setDob] = useState("")
    const [isWhatsAppNoSameAsContactNo, setIsWhatsAppNoSameAsContactNo] = useState(false)
    const [whatsAppCountryCode, setWhatsAppCountryCode] = useState<any>(null)
    const [whatsAppNumber, setWhatsAppNumber] = useState("")
    const [gender, setGender] = useState<any>(null)

    useEffect(() => {
        updateBasicDetails()
    }, [profileDetails])

    const updateBasicDetails = () => {
        setDisplayName(profileDetails.displayName)
        setUsername(profileDetails.username)
        setEmail(profileDetails.email)
        /* 
        This is done to make sure the reducer and the input values are same and additional calls can be ignored
        In handleSubmit2() -> if (profileDetails[source] !== value) ....
        */
        const formatedDob = moment(profileDetails.dob).format("YYYY-MM-DD")
        setDob(formatedDob)
        if (profileDetails.dob !== formatedDob) {
            const updateDobInReducer = {
                dob: formatedDob
            }
            dispatch(updateProfileFields(updateDobInReducer))
        }



        let countryDetails = null
        if (profileDetails.whatsAppCountryCode) {
            const whatsAppCountryCode_ = removeLeadingPlus(profileDetails.whatsAppCountryCode)
            countryDetails = getCountryByValue(whatsAppCountryCode_)
        } else {
            countryDetails = getCountryByValue("91")
        }
        if (countryDetails) {
            const whatsAppCountryCodeObj = {
                value: countryDetails.value,
                label: countryDetails.label
            }
            setWhatsAppCountryCode(whatsAppCountryCodeObj)
        }



        if (profileDetails.whatsAppNumber) {
            setWhatsAppNumber(formatNumberInputWithSpaceAfter5Numbers(profileDetails.whatsAppNumber))
        }
        if (profileDetails.countryCode === profileDetails.whatsAppCountryCode
            && profileDetails.whatsAppNumber === profileDetails.contactNumber) {
            setIsWhatsAppNoSameAsContactNo(true)
        }


        if (profileDetails.gender) {
            const genderObj = {
                value: profileDetails.gender,
                label: capitalizeFirstLetter(profileDetails.gender)
            }
            setGender(genderObj)
        }

    }

    const handleOnCheckBoxChanged = (e: any, source: string) => {
        const val = e.target.checked
        if (source === listOfSections.whatsAppNumber) {
            setIsWhatsAppNoSameAsContactNo(val)
            if (val) {
                setWhatsAppNumber(formatNumberInputWithSpaceAfter5Numbers(profileDetails.contactNumber))
                const countryCode_ = removeLeadingPlus(profileDetails.countryCode)
                let countryDetails = getCountryByValue(countryCode_)
                if (countryDetails) {
                    const whatsAppCountryCodeObj = {
                        value: countryDetails.value,
                        label: countryDetails.label
                    }
                    setWhatsAppCountryCode(whatsAppCountryCodeObj)
                }
            }
        }
    }

    const handleInputChange = (e: any, source: string) => {
        setErrMsg('')
        const val = e.target.value
        if (source === listOfSections.displayName) {
            setDisplayName(val);
        } else if (source === listOfSections.username) {
            setUsername(val)
        } else if (source === listOfSections.email) {
            setEmail(val)
        } else if (source === listOfSections.dob) {
            setDob(val)
        } else if (source === listOfSections.whatsAppCountryCode) {
            const countryDetails = getCountryByValue(val)
            if (countryDetails) {
                const whatsAppCountryCodeObj = {
                    value: val,
                    label: countryDetails.label
                }
                setWhatsAppCountryCode(whatsAppCountryCodeObj)
            }
        } else if (source === listOfSections.whatsAppNumber) {
            setWhatsAppNumber(formatNumberInputWithSpaceAfter5Numbers(val))
        } else if (source === listOfSections.gender) {
            const genderObj = {
                value: val,
                label: capitalizeFirstLetter(val)
            }
            setGender(genderObj)
        }
    };

    const handleSubmit = async (source: string) => {
        setErrMsg('')
        setIsSubmitBtnLoading(true)
        // debugger
        if (source === listOfSections.displayName) {
            handleSubmit2(displayName, listOfSections.displayName)
        } else if (source === listOfSections.username) {
            const validationCheck = isValidUsername(username)
            if (validationCheck.status) {
                handleSubmit2(username, listOfSections.username)
            } else {
                setErrMsg(validationCheck.message)
                setIsSubmitBtnLoading(false)
            }
        } else if (source === listOfSections.email) {
            const validationCheck = isValidEmail(email)
            if (validationCheck.status) {
                handleSubmit2(email, listOfSections.email)
            } else {
                setErrMsg(validationCheck.message)
                setIsSubmitBtnLoading(false)
            }
        } else if (source === listOfSections.otpVerification) {
            handleSubmit2(true, "isEmailVerified")
        } else if (source === listOfSections.dob) {
            const age = moment().diff(moment(dob, "YYYY-MM-DD"), "years");
            if (age >= 15) {
                const dobToSave = moment(dob).format("YYYY-MM-DD");
                handleSubmit2(dobToSave, listOfSections.dob)
            } else {
                setErrMsg(common.statusText.age15Err)
                setIsSubmitBtnLoading(false)
            }
        } else if (source === listOfSections.gender) {
            if (gender && gender.value) {
                handleSubmit2(gender.value, listOfSections.gender)
            } else {
                setErrMsg(common.statusText.pleaseGiveInput)
                setIsSubmitBtnLoading(false)
            }
        } else if (source === listOfSections.whatsAppNumber) {
            const whatsAppDetails = handleWhatsAppDetailsSubmit()
            if (Object.entries(whatsAppDetails).length > 0) {
                handleSubmit3(whatsAppDetails)
            } else {
                setErrMsg(common.statusText.pleaseGiveInput2)
                setIsSubmitBtnLoading(false)
            }
        }
    }

    const handleWhatsAppDetailsSubmit = () => {
        let whatsAppDetails = {}
        const countryDetails = getCountryByValue(whatsAppCountryCode.value)
        if ((whatsAppNumber != "" && whatsAppNumber.length >= 10) && countryDetails) {
            whatsAppDetails = {
                whatsAppCountryCode: "+" + whatsAppCountryCode.value,
                whatsAppNumber: undo_formatNumberInputWithSpaceAfter5Numbers(whatsAppNumber),
                whatsAppCountry: countryDetails.name
            };
        }
        return whatsAppDetails
    }

    const handleSubmit2 = async (value: any, source: string) => {
        if (value !== "") {

            // START : Special case gender should always be submitted
            if (source === listOfSections.gender) {
                const updateObj = {
                    [source]: value
                }
                const updateUserProfileApiCallStatus = await updateUserProfileApiCall(updateObj)
                if (updateUserProfileApiCallStatus.status) {
                    dispatch(setProfileStepNo(profileStepNo + 1))
                    dispatch(updateProfileFields(updateObj))
                } else {
                    setErrMsg(common.statusText.issueInUpdating)
                }
                return
            }
            // END : Special case gender should always be submitted


            if (profileDetails[source] !== value) {
                const updateObj = {
                    [source]: value
                }
                const updateUserProfileApiCallStatus = await updateUserProfileApiCall(updateObj)
                if (updateUserProfileApiCallStatus.status) {
                    dispatch(setProfileStepNo(profileStepNo + 1))
                    dispatch(updateProfileFields(updateObj))
                } else {
                    setErrMsg(common.statusText.issueInUpdating)
                }
            } else {
                // this if condition is to skip email verification if email is not changed
                if (source === listOfSections.email) {
                    if (profileDetails["isEmailVerified"]) {
                        dispatch(setProfileStepNo(profileStepNo + 2))
                    } else {
                        dispatch(setProfileStepNo(profileStepNo + 1))
                    }
                } else {
                    dispatch(setProfileStepNo(profileStepNo + 1))
                }
            }
        } else {
            setErrMsg(common.statusText.pleaseGiveInput)
        }
        setIsSubmitBtnLoading(false)
    }



    const handleSubmit3 = async (updatedFields: any) => {
        const fieldsToUpdate: any = {};
        let anyFieldChanged = false;
        let anyValueEmpty = false

        for (const source in updatedFields) {
            if (Object.prototype.hasOwnProperty.call(updatedFields, source)) {
                const newValue = updatedFields[source];
                const currentValue = profileDetails[source];
                if (newValue === "") {
                    anyValueEmpty = true
                }
                if (newValue !== "" && newValue !== currentValue) {
                    fieldsToUpdate[source] = newValue;
                    anyFieldChanged = true;
                }
            }
        }

        if (Object.keys(fieldsToUpdate).length > 0) {
            const updateUserProfileApiCallStatus = await updateUserProfileApiCall(fieldsToUpdate);

            if (updateUserProfileApiCallStatus.status) {
                dispatch(setProfileStepNo(profileStepNo + 1));
                dispatch(updateProfileFields(fieldsToUpdate));
            } else {
                setErrMsg(common.statusText.issueInUpdating);
            }
        } else {
            if (anyValueEmpty) {
                setErrMsg(common.statusText.pleaseGiveInput2);
            }

            dispatch(setProfileStepNo(profileStepNo + 1));
        }

        setIsSubmitBtnLoading(false);
    };


    function isValidUsername(input: string) {
        let ret = {
            status: false,
            message: ""
        }
        if (input != "") {
            const regex = /^[a-zA-Z0-9_]{4,15}$/;
            const test = regex.test(input);
            if (test) {
                ret.status = true
            } else {
                ret.message = common.statusText.validationInstruction1
            }
        } else {
            ret.message = common.statusText.pleaseGiveInput
        }
        return ret
    }

    function isValidEmail(email: string) {
        let ret = {
            status: false,
            message: ""
        }
        if (email !== "") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const test = emailRegex.test(email);
            if (test) {
                ret.status = true
            } else {
                ret.message = common.statusText.inValidEmailWarn
            }
        } else {
            ret.message = common.statusText.pleaseGiveInput
        }
        return ret
    }
    return (
        <>
            <BasicDetailsView
                errMsg={errMsg}
                isSubmitBtnLoading={isSubmitBtnLoading}
                handleInputChange={handleInputChange}
                handleSubmit={handleSubmit}
                profileStepNo={profileStepNo}
                displayName={displayName}
                username={username}
                email={email}
                dob={dob}
                isWhatsAppNoSameAsContactNo={isWhatsAppNoSameAsContactNo}
                handleOnCheckBoxChanged={handleOnCheckBoxChanged}
                whatsAppCountryCode={whatsAppCountryCode}
                whatsAppNumber={whatsAppNumber}
                gender={gender}
            />
        </>
    );
}
